import { NgModule } from '@angular/core';
import { PdfWheelZoomDirective } from './pdf-wheel-zoom.directive';

@NgModule({
  declarations: [PdfWheelZoomDirective],
  exports: [PdfWheelZoomDirective],
})
export class PdfWheelZoomModule {}
